import Head from 'next/head'
import Image from 'next/image'
import Nav from '@/components/Nav';
import Footer from '@/components/Footer';
import groq from 'groq';
import client from '../sanity_client';
import {urlFor} from '../sanity_image';
import {toHTML} from '@portabletext/to-html';
import React, { useState } from "react";
import Banner from '@/components/PageBanner';
import ContactForm from '@/components/ContactForm';

export default function Application({pageContent, dataPoints, siteSettings}:any) {
  return (
    <>
      <Head>
        <title>The Line of Sight &#8480;</title>
      </Head>
      <Nav />
        <main className="row">
          <Banner bannerHeading={pageContent[0].banner_heading} bannerSubHeading={pageContent[0].banner_sub_heading} bannerImage={urlFor(pageContent[0].banner_image).width(1920).url()} />
          <div className="col-12">
            <div className="container">
              <div className="row">
                <div className="col-12 application-content regular-font">
                  <div dangerouslySetInnerHTML={{__html: toHTML(pageContent[0].content)}}>
                    {/* */}
                  </div>
                  <hr />
                </div>
                {dataPoints.map((dataPoint:any) => (
                  <div key={dataPoint._id} className="col-12">
                    <div className="row">
                      {dataPoint.sort_order % 2 == 0 ?
                        <>
                          <div className="col-12 col-sm-6">
                            <img className="data-point-img" src={urlFor(dataPoint.image).width(1000).url()} />
                          </div>
                          <div className="col-12 col-sm-6 data-point">
                            <div className="content">
                              <div className="title title-font">{dataPoint.heading}</div>
                              <div className="sub-title subtitle-font">{dataPoint.sub_heading}</div>
                              <div className="text regular-font" dangerouslySetInnerHTML={{__html: toHTML(dataPoint.description)}}>
                                {/* */}
                              </div>
                            </div>
                          </div>
                        </>
                      :
                        <>
                          <div className="col-12 col-sm-6 data-point">
                            <div className="content">
                              <div className="title title-font">{dataPoint.heading}</div>
                              <div className="sub-title subtitle-font">{dataPoint.sub_heading}</div>
                              <div className="text regular-font" dangerouslySetInnerHTML={{__html: toHTML(dataPoint.description)}}>
                                {/* */}
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-sm-6">
                            <img className="data-point-img" src={urlFor(dataPoint.image).width(1000).url()} />
                          </div>
                        </>
                      }
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <ContactForm adminEmails={siteSettings[0].admin_emails} />
        </main>
      <Footer />
    </>
  )
}

export async function getServerSideProps() {
  const pageContent = await client.fetch(groq`*[_type == "applicationPage"]`);
  const dataPoints = await client.fetch(groq`*[_type == "applicationDataPoint"] | order(sort_order asc)`);
  const siteSettings = await client.fetch(groq`*[_type == "siteSettings"]`);
  return {
    props: {
      pageContent: pageContent,
      dataPoints: dataPoints,
      siteSettings: siteSettings
    }
  }
}
